<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <div class="row" style="padding: 5px">
        <div class="col-12 mb-4">
                        <v-card>
                            <v-data-table
                                :headers="headers"
                                :items="other_users"
                                :search="search"
                                sort-by="label"
                                class="elevation-1"
                                :loading="users===undefined" loading-text="Chargement en cours...">
                                    <template v-slot:item.image="{item}">
                                        <span>
                                            <img class="circular--square" :src="'/'+item.image.cropped" alt="">
                                        </span>
                                     </template>
                                    <template v-slot:item.country="{item}" >
                                        <country-flag  v-if="item.country" :title="item.country._name" :country=" item.country._code" size='normal'/>
                                     </template>

                                <template v-slot:item.role._label="{item}">
                                    <v-overflow-btn
                                    dense
                                            :items="drop_down_user_roles"
                                            :label="item.role._label"
                                            target="#dropdown-example"
                                            @input="userRoleChanged"
                                            @change="changeUserRole(item)">
                                    </v-overflow-btn>
                                </template>
                                <template v-slot:item._email_verified_at="{item}">
                                    <v-chip class="ma-2 text-white" :color="(item._email_verified_at!==null)?'success':'orange'">{{(item._email_verified_at!==null)?'Vérifié':'Non vérifié'}}</v-chip>
                                </template>
                                <template v-slot:item._created_at="{item}">
                                    {{ new Date(item._created_at).toLocaleDateString()}}
                                </template>
                                <template v-slot:top>
                                    <v-row style="background: #f8f8f8;">
                                    <v-col cols="12" sm="4">
                                        <v-overflow-btn
                                        dense
                                                :items="drop_down_roles"
                                                label="Filtrer par rôle"
                                                target="#dropdown-example"
                                                v-model="role_key"
                                                @change="filterUsers('role')">
                                        </v-overflow-btn>
                                    </v-col>
                                    <v-col cols="12" sm="4">
                                        <v-overflow-btn
                                        dense
                                                :items="drop_down_user_countries"
                                                label="Filtrer par pays"
                                                target="#dropdown-example"
                                                v-model="country_key"
                                                @change="filterUsers('country')">
                                        </v-overflow-btn>
                                    </v-col>
                                        <v-col cols="12" sm="4">
                                            <v-text-field
                                                    v-model="search"
                                                    append-icon="mdi-magnify"
                                                    label="Search"
                                                    single-line
                                                    hide-details
                                            ></v-text-field>
                                    </v-col>
                                    </v-row>
                                </template>
                            <template v-slot:item.etat="{ item }">
                                    <v-switch @click="changeUserStatus(item)" color="primary" :input-value="(item._active)?'true':''"></v-switch>
                            </template>
                                <template v-slot:item.actions="{ item }">
                                    <div style="text-align:  right">
                                        <v-menu
                                                key="text"
                                                rounded="b-xl"
                                        >
                                            <template v-slot:activator="{ attrs, on }">

                                                <v-icon

                                                        class="black--text "
                                                        v-bind="attrs"
                                                        v-on="on"
                                                        @click="setUserId(item)">mdi-dots-vertical</v-icon>

                                            </template>
                                            <v-list>
                                                <v-list-item
                                                        v-for="(action_item, index) in actions_items"
                                                        :key="index"
                                                        link
                                                        @click="editItemAction(item,index)">
                                                    <v-list-item-icon>
                                                        <v-icon color="#29B3A6">{{action_item.avatar}}</v-icon>
                                                    </v-list-item-icon>
                                                    <v-list-item-content>
                                                        <v-list-item-title v-text="action_item.title"></v-list-item-title>
                                                    </v-list-item-content>
                                                </v-list-item>
                                            </v-list>
                                        </v-menu>
                                    </div>
                                </template>
                                <template v-slot:no-data>
                                <span>{{$t('users.no_users_found')}}</span>
                            </template>
                        </v-data-table>
                            <!-- <v-dialog max-width="500" v-model="serviceDialog">
                                <v-card>
                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn class="dark" text @click="serviceDialog = false">{{$t("close")}}</v-btn>
                                    </v-card-actions>
                                    <v-card-title>Services</v-card-title>
                                    <v-list>
                                        <v-list-item v-for="(service, index) in serviceData" :key="index">
                                            <v-list-item-action>
                                                <v-switch @click="handleActivation(service)"></v-switch>
                                            </v-list-item-action>

                                            <v-list-item-content v-text="service._name"></v-list-item-content>
                                        </v-list-item>
                                    </v-list>
                                </v-card>
                            </v-dialog> -->
                        </v-card>
            </div>
        </div>
</template>

<script>
    /* eslint-disable */
    import {mapState} from "vuex";
    import * as Swal from "sweetalert2";
    import {roles} from "../../../../store/roles";
    import {client} from "@/store/services/client";

    export default {
        label: "OtherUsers",
        data () {
            return {
                role_key:'',
                country_key:'',
                submitting:false,
                valid:true,
                lazy:false,
                errors:{},
                search: '',
                dialog: '',
                id:undefined,
                serviceDialog: false,
                serviceData: undefined,
                userId: '',
                serviceId: '',
                headers: [
                    {text: 'Image', value: 'image'},
                    {text: 'Nom', value: '_last_name'},
                    {text: 'Prénom', value: '_first_name'},
                    {text: 'Email', value: '_email'},
                    {text: 'Téléphone', value: '_phone'},
                    {text: 'Pays', value: 'country'},
                    {text: 'Type de Compte', value: 'role._label'},
                    {text: 'Vérification', value: '_email_verified_at'},
                    {text: 'Date', value: '_created_at'},
                    { text: 'Etat', value: 'etat', sortable: false },
                    { text: '', value: 'actions', sortable: false },

                ],
                editedIndex: -1,
                editedItem: {},
                user_role:'',
                actions_items: [
                    { title: "Activités", avatar: 'mdi-history' },
                    { title: "Services", avatar: 'mdi-toolbox-outline' },
                    { title: "Détails", avatar: 'mdi-eye' }
                ],

            }
        },
        computed: {
            formTitle () {
                return this.editedIndex === -1 ? this.$t('users.new_user') : this.$t('users.update_user')
            },

            ...mapState('users/',['users']),
            ...mapState('roles/',['roles']),
            drop_down_roles: function(){
                let arr = [{text:"Tous les utilisateurs",value:-1}];
                if (this.roles){
                    this.roles.forEach((role)=>{
                        if (!role._code.includes('admin'))
                        arr.push({text:role._label,value:role._id})
                    });
                }
                return arr;
                },
            drop_down_user_roles: function(){
                let arr = [];
                if (this.roles){
                    this.roles.forEach((role)=>{
                            arr.push({text:role._label,value:role._id})
                    });
                }

                return arr;
                },
            drop_down_user_countries: function(){
                let arr = [{text:"Tous les utilisateurs",value:-1}];

                if (this.countries){
                    this.countries.forEach((country)=>{
                        arr.push({text:country._name,value:country._id})
                    });
                }

                return arr;
                },
            other_users: function(){
                let arr = [];
                if (this.users){
                    this.users.forEach((user)=>{
                        if (!user.role._code.includes('admin'))
                            arr.push(user)
                    });
                }
                return arr;
            },
            ...mapState('countries/', ['countries'])

        },
        mounted(){
            this.initialize();
            this.$store.dispatch('countries/getCountries').then(response => {});

        },
        watch: {
            dialog (val) {
                val || this.close()
            },
        },
        methods: {
            initialize () {
                this.$store.dispatch('users/getUsers').then(response=>{});
                this.$store.dispatch('roles/getRoles').then(response=>{});
                this.dropdownRoles();
            },
            dropdownRoles(){
                if (this.roles){
                    this.roles.forEach((role)=>{
                        this.drop_down_roles.push({text:role._label,value:role._id})
                    });
                }
                return this.drop_down_roles;
            },
            editItem (item) {
                this.editedIndex = this.users.indexOf(item)
                this.editedItem = Object.assign({}, item)
                this.dialog = true
                this.id = item._id;
            },
            editItemAction(item,index) {
                console.log(index,'************ index data focus reverse ********')
                switch (index){
                    case 0:
                        this.goToUserHistories(item._id)
                    break;
                    case 1:
                        this.goToServiceDetails(item._id);
                    break;
                    case 2:
                        this.goToUserDetails(item._id)
                    break;
                }
            },
            deleteItem (item) {
                const index = this.users.indexOf(item)
                Swal.fire({
                    icon: 'warning',
                    timerProgressBar: false,
                    text: this.$t('delete_warning'),
                    confirmButtonText:  this.$t('delete'),
                    cancelButtonText: this.$t('cancel'),
                    showCancelButton: true,
                    cancelButtonColor:"#29B3A6",
                    confirmButtonColor:"#CCC"
                }).then(result => {
                    if (result.value) {
                        this.$store.dispatch('users/deleteUser', item._id).then((result) => {
                            Swal.fire({
                                icon: 'success',
                                timer: 3000,
                                timerProgressBar: false,
                                text: this.$t(result.message),
                                position: 'top-end',
                                showConfirmButton: false
                            })
                        })
                    }
                })
            },
           
            setUserId(item) {
                this.userId = item._id;
            },
            changeUserStatus (item) {
                let VueBox = this;
                if (item._email_verified_at==null){
                    Swal.fire({
                        icon: 'error',
                        timerProgressBar: false,
                        text: this.$t('users.should_verify_email'),
                        position: 'top-end',
                        showConfirmButton: true
                    });
                    return;
                }
                let message = (item._active)?'users.deactivate_warning':'users.activate_warning';
                let action = (item._active)?'users.deactivate':'users.activate';

                if (item._active){
                    Swal.fire({
                        title:this.$t('enter_reason') ,
                        input: 'textarea',
                        inputAttributes: {
                            autocapitalize: 'off'
                        },
                        showCancelButton: true,
                        confirmButtonText:  this.$t(action),
                        cancelButtonText: this.$t('cancel'),
                        cancelButtonColor:"#CCC",
                        confirmButtonColor:'#29B3A6',
                        showLoaderOnConfirm: true,
                        preConfirm: (reason) => {
                            let data = {reason:reason,id: item._id}
                            return this.$store.dispatch('users/changeUserStatus',data).then((result) => {
                                if (result.error) {
                                    Swal.showValidationMessage(
                                        VueBox.$t(result.message)
                                    )
                                }
                                    return result;

                            })

                        },
                        allowOutsideClick: () => !Swal.isLoading()
                    }).then((result) => {
                        if (result.value) {
                            Swal.fire({
                                text: VueBox.$t(result.value.message),
                            })
                        }
                    })
                }else{
                    Swal.fire({
                  icon: 'warning',
                  timerProgressBar: false,
                  text: this.$t(message),
                  confirmButtonText:  this.$t(action),
                  cancelButtonText: this.$t('cancel'),
                  showCancelButton: true,
                  cancelButtonColor:"#CCC",
                  confirmButtonColor:'#29B3A6'
              }).then(result => {
                  if (result.value) {
                      this.$store.dispatch('users/changeUserStatus',{id:item._id,reason:''}).then(() => {
                         if (result.error) {
                             Swal.fire({
                                 icon: 'error',
                                 timer: 3000,
                                 timerProgressBar: false,
                                 text: this.$t(result.message),
                                 showConfirmButton: true,
                                 confirmButtonColor:'#29B3A6'

                             })
                         }
                      })
                  }
              })
                }
            },
            userRoleChanged(value){
                this.role_key  = value;
            },
            changeUserRole(user){
                this.$store.dispatch('users/changeUserRole', {id:user._id,role:this.role_key}).then((result) => {
                    if (!result.error) {
                        Swal.fire({
                            icon: 'success',
                            timer: 3000,
                            timerProgressBar: false,
                            text: this.$t('users.role_updated'),
                            showConfirmButton: true,
                            confirmButtonColor:'#29B3A6'

                        })
                    }
                })
            },
            goToUserHistories(id){
                let url = '/users/account/histories/'+id;
                this.$router.push(url);
            },
            goToUserDetails(id){
                let url = '/users/'+id;
                this.$router.push(url);
            },
             goToServiceDetails(id){
                let url = '/services/user/'+id;
                console.log(url,'************ url data **********')
                this.$router.push(url);
            },
            close () {
                this.dialog = false;
                this.$nextTick(() => {
                    this.editedItem = Object.assign({}, this.defaultItem)
                    this.editedIndex = -1
                });
                this.$refs.form.reset()
            },
            save () {
                    let VueBox = this;
                    let data = new FormData();
                    data.append("code",this.editedItem._code);
                    data.append("label",this.editedItem._label);
                    if (this.id)
                        data.append("id",this.id);
                    this.$store.dispatch('users/setUser',data).then((response)=>{
                      console.log('set user response',response)
                        if (response.error){
                            this.errors.operation=response.message;
                        }else{
                            VueBox.$parent.resetDatas(VueBox);
                            this.close();
                        }
                    })
            },
            validate () {
                this.$refs.form.validate()
            },
            reset () {
                this.$refs.form.reset()
            },
            checkisDashboard(){
                this.$emit('checkisDashboard',true);
            },
            fileChange() {
                console.log( this.$refs);
                this.editedItem._file = this.$refs.file.files[0];
            },
            getFileOriginalName(file){
                return file.substr(file.lastIndexOf('/')+1)
            },
            filterUsers(criteria){
                this.users = undefined;
                if (criteria==="role")
                this.$store.dispatch('users/filterUsersByRole', this.role_key).then(() => {});
                else
                this.$store.dispatch('users/filterUsersByCountry', this.country_key).then(() => {});

            }
        },
        created() {
            this.checkisDashboard();
            this.initialize()
        },
        
    }
</script>

<style scoped>
    .circular--square {
        border-radius: 50%;
    }
    .circular--square {
        border-radius: 50% 50%;
        width: 50px;
        height: 50px;
        object-fit: contain;
    }
</style>
